export const alyviaCoreServiceApi = process.env.REACT_APP_ALYVIA_CORE_API;
export const alyviaAuth0Domain =
  process.env.REACT_APP_ALYVIA_AUTH0_DOMAIN || "";
export const alyviaAuth0ClientId =
  process.env.REACT_APP_ALYVIA_AUTH0_CLIENT_ID || "";
export const alyviaAuth0Audience =
  process.env.REACT_APP_ALYVIA_AUTH0_AUDIENCE || "";
export const defaultContainerWidth = "90vw";
export const alyviaCookieDomain = process.env.REACT_APP_ALYVIA_COOKIE_DOMAIN || ""
export const JWT_TOKEN_KEY = `${alyviaCookieDomain}_jwt_token`
export const DEFAULT_HEIGTH_TO_NAVBAR_AND_CHAT_HEADER = 70 // value set to pixel, then use as ${value}px to build the string correctly
